import React from 'react';
import { createPortal } from 'react-dom';
import { Spin } from 'antd';
import { useViewerStore } from '../../../../store/store';

const AI_LOADING_OVERLAY_Z_INDEX = 100_000;

export const ViewerLoadingOverlays: React.FC = () => {
    const simulatingLayouts = useViewerStore((s: any) => Boolean(s.simulatingLayouts));
    const simulatingLayoutIndex = useViewerStore((s: any) => Number((s as any).simulatingLayoutIndex || 0));
    const simulatingLayoutTotal = useViewerStore((s: any) => Number((s as any).simulatingLayoutTotal || 0));

    const aiLoading = useViewerStore((s: any) => Boolean(s.aiLoading));
    const aiLoadingStep = useViewerStore((s: any) => (typeof (s as any).aiLoadingStep === 'string' ? (s as any).aiLoadingStep : ''));
    const aiRunElapsedMs = useViewerStore((s: any) => (typeof s.aiRunElapsedMs === 'number' ? s.aiRunElapsedMs : null));
    const reRunningTreeScenarios = useViewerStore((s: any) => Boolean(s.reRunningTreeScenarios));
    const treeReprocessInProgress = useViewerStore((s: any) => Boolean((s as any).treeReprocessInProgress));

    return (
        <>
            {simulatingLayouts && !reRunningTreeScenarios && !treeReprocessInProgress && (
                <div
                    className="editor-simulating-layouts-overlay"
                    style={{
                        position: 'fixed',
                        bottom: 24,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 99998,
                        padding: '12px 24px',
                        borderRadius: 999,
                        background: 'rgba(18,22,28,0.8)',
                        border: '1px solid rgba(100,180,255,0.4)',
                        color: 'rgba(255,255,255,0.95)',
                        fontSize: 14,
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        pointerEvents: 'none',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    }}
                >
                    <Spin size="small" style={{ color: 'rgba(100,180,255,0.9)' }} />
                    <span>Trying different layouts...</span>
                    {simulatingLayoutTotal > 0 && (
                        <span style={{ opacity: 0.9, fontWeight: 500 }}>
                            Layout {simulatingLayoutIndex} of {simulatingLayoutTotal}
                        </span>
                    )}
                </div>
            )}

            {aiLoading
                ? createPortal(
                      <div
                          className="editor-ai-loading-overlay"
                          style={{
                              position: 'fixed',
                              inset: 0,
                              zIndex: AI_LOADING_OVERLAY_Z_INDEX,
                              background: 'rgba(18,22,28,0.55)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              pointerEvents: 'auto',
                              gap: 20,
                          }}
                      >
                          <Spin size="large" style={{ color: 'rgba(100,180,255,0.9)' }} />
                          <div style={{ color: 'rgba(255,255,255,0.95)', fontSize: 15, fontWeight: 600 }}>
                              {aiLoadingStep || 'Running AI...'}
                          </div>
                          {aiRunElapsedMs != null && (
                              <div style={{ color: 'rgba(248,250,252,0.9)', fontSize: 13, marginTop: 4 }}>
                                  Elapsed: {(aiRunElapsedMs / 1000).toFixed(1)}s
                              </div>
                          )}
                          <div
                              style={{
                                  color: 'rgba(255,255,255,0.65)',
                                  fontSize: 13,
                                  maxWidth: 320,
                                  textAlign: 'center',
                                  lineHeight: 1.5,
                              }}
                          >
                              This can take up to ~1-5 minutes. You can see the viewer trying layout variants behind.
                          </div>
                      </div>,
                      document.body,
                  )
                : null}

            {reRunningTreeScenarios && (
                <div
                    className="editor-ai-rerun-loading-overlay"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 100000,
                        background: 'rgba(18,22,28,0.8)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'auto',
                        gap: 16,
                    }}
                >
                    <Spin size="large" style={{ color: 'rgba(100,180,255,0.9)' }} />
                    <div style={{ color: 'rgba(255,255,255,0.95)', fontSize: 14, fontWeight: 600 }}>
                        Re-running tree-cutting scenarios...
                    </div>
                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>
                        Updating scenario data with current layout.
                    </div>
                </div>
            )}
        </>
    );
};

